import React, { FunctionComponent } from 'react'
import {
  Redirect,
  // Redirect,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router-dom'

import { AppContainer, LinkInfoContainer } from '../../containers'
import { Err401, Err404 } from '../../components'
// import { Dashboard } from '../../pages'

import AdvertisersRouter from './advertisers'
import LinksRouter from './links'
import AlertsRouter from './alerts'
import SupportRouter from './support'
import PropertiesRouter from './properties'
import AppUsersRouter from './appUsers'
import Reports from './reports'
import Payments from './payments'

import RestrictedRoute from '../util/RestrictedRoute'
import PublisherRouter from './publisher'

const AppRouter: FunctionComponent<RouteComponentProps> = ({ match }) => {
  return (
    <AppContainer>
      <Switch>
        <Redirect exact path={match.path} to="/new/reports/overview-report" />
        <Route path={`${match.path}/unauthorized`} render={() => <Err401 />} />
        <RestrictedRoute
          path={`${match.path}/programs`}
          render={AdvertisersRouter}
        />
        <RestrictedRoute path={`${match.path}/reports`} component={Reports} />
        {/* <RestrictedRoute path={`${match.path}/payments`} component={Payments} /> */}
        <RestrictedRoute path={`${match.path}/links`} component={LinksRouter} />
        <RestrictedRoute
          path={`${match.path}/link-info`}
          component={LinkInfoContainer}
        />
        <RestrictedRoute
          path={`${match.path}/alerts`}
          component={AlertsRouter}
        />
        <RestrictedRoute
          path={`${match.path}/support`}
          component={SupportRouter}
        />
        <RestrictedRoute
          path={`${match.path}/properties`}
          component={PropertiesRouter}
        />
        <RestrictedRoute
          path={`${match.path}/users`}
          minimumRequiredRole="manager"
          component={AppUsersRouter}
        />
        <RestrictedRoute
          path={`${match.path}/publisher`}
          minimumRequiredRole="manager"
          component={PublisherRouter}
        />
        <Route render={() => <Err404 isInternal />} />
      </Switch>
    </AppContainer>
  )
}

export default AppRouter
